import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "img1 h-auto" }, null, -1)

import { HomeContainer } from "@/components/atoms"
import FAQExternal from "../components/organisms/FaqExternal.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'FaqExternalPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(HomeContainer), null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(FAQExternal)
    ]),
    _: 1
  }))
}
}

})